import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {
    Layout,
    Input,
    Avatar,
    Space,
    Dropdown,
    Button,
    Typography,
    Grid,
    Tooltip,
} from "antd";
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UserOutlined,
    LogoutOutlined,
    QuestionCircleOutlined,
    SearchOutlined,
    DownOutlined,
    IdcardOutlined,
} from "@ant-design/icons";
import {useDashboardDataContext} from "@/context/dashboardDataContext";
import {useDispatch, useSelector} from "react-redux";
import {fetchProfile} from "@/store/profileApi/profileThunk";
import {clearTokens} from "@/utils/tokenCookies";

// ✅ Cookie boshqaruvi uchun funksiya
const setCookie = (name, value, days = 7) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

const getCookie = (name) => {
    const match = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return match ? decodeURIComponent(match.pop()) : null;
};

const {Header} = Layout;
const {Text} = Typography;
const {useBreakpoint} = Grid;

const VerticalNav = () => {
    const screens = useBreakpoint();
    const isMobile = !screens.md;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {profile} = useSelector((state) => state.profileApi || {});
    const {sidebarMini, setSidebarMini} = useDashboardDataContext();

    const [selectedRole, setSelectedRole] = useState("");

    useEffect(() => {
        dispatch(fetchProfile());
    }, [dispatch]);

    // ✅ Profil kelgandan keyin birinchi rolni cookie'ga yozish
    useEffect(() => {
        if (profile?.roles?.length) {
            const savedRole = getCookie("selectedRole");
            if (!savedRole) {
                setCookie("selectedRole", profile.roles[0].name);
                setSelectedRole(profile.roles[0].name);
            } else {
                setSelectedRole(savedRole);
            }
        }
    }, [profile]);

    const handleLogout = () => {
        clearTokens();
        navigate("/login");
    };

    // ✅ Rolni almashtirish
    const handleRoleSelect = (roleName) => {
        setCookie("selectedRole", roleName);
        setSelectedRole(roleName);
    };

    // ✅ Profile sahifasiga o'tish
    const handleProfileClick = () => {
        navigate("/dashboard/user");
    };

    // 🌟 Dropdown menyu
    const menuItems = [
        {
            key: "user-info",
            label: (
                <div
                    onClick={handleProfileClick}

                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        padding: "10px 8px",
                        borderBottom: "1px solid #f0f0f0",
                    }}
                >
                    <Avatar
                        size={32}
                        src={profile?.picture || undefined}
                        icon={!profile?.picture ? <UserOutlined/> : null}
                    />
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <Text strong style={{fontSize: 12}}>
                            {`${profile?.surname || ""} ${profile?.first_name || ""}`}
                        </Text>
                        <Text type="secondary" style={{fontSize: 12}}>
                            {profile?.employee_id || "Foydalanuvchi"}
                        </Text>
                    </div>
                </div>
            ),

        },
        ...(profile?.roles?.map((role, index) => ({
            key: `role-${index}`,
            label: (
                <div
                    style={{
                        padding: "6px 10px",
                        borderRadius: 6,
                        transition: "0.2s",
                        backgroundColor:
                            selectedRole === role.name ? "rgba(24,144,255,0.1)" : "transparent",
                        fontWeight: selectedRole === role.name ? 600 : 400,
                        color: selectedRole === role.name ? "#1890ff" : "#333",
                    }}
                    onClick={() => handleRoleSelect(role.name)}
                    onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor =
                            selectedRole === role.name ? "rgba(24,144,255,0.15)" : "#f5f5f5")
                    }
                    onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                            selectedRole === role.name ? "rgba(24,144,255,0.1)" : "transparent")
                    }
                >
                    {role.name}
                </div>
            ),
        })) || []),
        {
            type: "divider",
        },
        {
            key: "profile",
            label: (
                <Button
                    type="default"
                    block
                    icon={<IdcardOutlined/>}
                    style={{
                        fontWeight: 500,
                        borderRadius: 8,
                        marginBottom: 8,
                    }}
                    onClick={handleProfileClick}
                >
                    Profil
                </Button>
            ),
        },
        {
            key: "logout",
            label: (
                <Button
                    type="primary"
                    danger
                    block
                    icon={<LogoutOutlined/>}
                    style={{
                        fontWeight: 500,
                        borderRadius: 8,
                    }}
                    onClick={handleLogout}
                >
                    Chiqish
                </Button>
            ),
        },
    ];

    return (
        <Header
            style={{
                background: "#fff",
                padding: "8px 20px",
                borderBottom: "1px solid #E2E8F0",
                display: "flex",
                alignItems: "center",
                position: "fixed",
                top: 0,
                left: isMobile ? 0 : sidebarMini ? 80 : 280, // 📱 mobil uchun har doim 0
                width: isMobile
                    ? "100%"
                    : `calc(100% - ${sidebarMini ? 80 : 280}px)`, // 📱 mobil uchun 100%
                justifyContent: "space-between",
                gap: 16,
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                zIndex: 9,
            }}
        >
            {/* Chap tomon */}
            <div style={{display: "flex", alignItems: "center", gap: 12}}>
                <Button
                    type="text"
                    onClick={() => setSidebarMini(!sidebarMini)}
                    icon={sidebarMini ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>}
                />
            </div>

            {/* Qidiruv */}
            {!isMobile && (
                <div style={{flex: 1, display: "flex", justifyContent: "center"}}>
                    <div style={{width: "100%", maxWidth: 760}}>
                        <Input
                            placeholder="Qidirish..."
                            prefix={<SearchOutlined style={{color: "#8f9bb3"}}/>}
                            allowClear
                            style={{
                                borderRadius: 28,
                                boxShadow: "0 2px 10px rgba(59,130,246,0.06)",
                                padding: "6px 14px",
                                background: "#fff",
                            }}
                        />
                    </div>
                </div>
            )}

            {/* O'ng tomon */}
            <div style={{display: "flex", alignItems: "center", gap: 12}}>
                {!isMobile && (
                    <Space size="small" align="center">
                        <Tooltip title="Jarayonda">
                            <Button
                                type="text"
                                shape="circle"
                                size="large"
                                icon={<QuestionCircleOutlined/>}
                            />
                        </Tooltip>
                    </Space>
                )}

                {/* Avatar + Dropdown */}
                <Dropdown menu={{items: menuItems}} placement="bottomRight" arrow trigger={["click"]}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            padding: "6px 8px",
                            borderRadius: 12,
                            cursor: "pointer",
                            transition: "0.3s",
                        }}
                    >
                        <Avatar
                            size={42}
                            src={profile?.picture || undefined}
                            icon={!profile?.picture ? <UserOutlined/> : null}
                        />
                        {!isMobile && (
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <Text strong style={{fontSize: 13}}>
                                    {`${profile?.surname || ""} ${profile?.first_name || ""}`}
                                </Text>
                                <Text type="secondary" style={{fontSize: 12}}>
                                    {selectedRole || profile?.roles?.[0]?.name || "Foydalanuvchi"}
                                </Text>
                            </div>
                        )}
                        <DownOutlined style={{color: "#8b93a7", fontSize: 12}}/>
                    </div>
                </Dropdown>
            </div>
        </Header>
    );
};

export default VerticalNav;